"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vitalFormToPayloadDataHandler = vitalFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function vitalFormToPayloadDataHandler(data) {
    const now = (0, dayjs_1.default)();
    return {
        form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (data.heartRate && { heartRate: `${data.heartRate}/minute` })), (data.bpSit && { bpSit: `${data.bpSit}mmHg` })), (data.bpStand && { bpStand: `${data.bpStand}mmHg` })), (data.repositoryRate && {
            repositoryRate: `${data.repositoryRate}/minute`,
        })), (data.temperature && { temperature: `${data.temperature} °F` })), (data.pulseOximetry && {
            pulseOximetry: `${data.pulseOximetry}% O2 Sat`,
        })), (data.pain && {
            pain: `${data.pain} out of 10`,
        })), (data.weight && {
            weight: `${data.weight} ${data.weightUnit}`,
        })), (data.bloodSugar && {
            bloodSugar: `${data.bloodSugar} mg/dl ${data.bloodSugarType}`,
        })), (data.location && { location: data.location })), (data.notes && { notes: data.notes })), { offSet: now.utcOffset() }),
    };
}
